import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'default' | 'highlighted';
  padding?: string;
}

export const Card: React.FC<CardProps> = ({ 
  children, 
  className = '', 
  variant = 'default',
  padding = 'p-5'
}) => {
  const baseClasses = `cy:bg-white cy:rounded-lg cy:${padding} cy:shadow-sm`;
  const variantClasses = {
    default: '',
    highlighted: 'cy:border-2 cy:border-purple-500'
  };
  
  return (
    <div className={`${baseClasses} ${variantClasses[variant]} ${className}`}>
      {children}
    </div>
  );
};

